import { Field } from 'formik';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Col, Collapse } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateData } from 'redux/realEstateSlice';
import Select from 'react-select';

export const ProjectData = ({
  setValues,
  values,
  errors,
  touched,
  data,
  realEstate
}) => {
  const dispatch = useDispatch();

  const branchOffices = useSelector(
    state => state.realEstate.branchOfficesArray
  );

  useEffect(() => {
    realEstate?.id && dispatch(getRealEstateData(realEstate.id));
  }, [realEstate]);

  const branchOfficesOptions = [
    { value: 0, label: '-- Selecciona la sucursal --' },
    ...branchOffices.map(suc => ({
      value: suc.id,
      label: suc.branch_office_name
    }))
  ];

  return (
    <>
      <Col xs={12} sm={5}>
        <label>
          Seleccione la Sucursal que gestionará el inmueble{' '}
          <span className="text-danger">*</span>
        </label>
        <Select
          name="branch_office_id"
          options={branchOfficesOptions}
          onChange={selectedOption => {
            setValues({
              ...values,
              branch_office_id: selectedOption.value
            });
          }}
          value={
            branchOfficesOptions.find(
              option => option.value === values.branch_office_id
            ) || branchOfficesOptions[0]
          }
          isSearchable={false}
        />
        {errors.branch_office_id && touched.branch_office_id && (
          <label style={{ color: '#da1717e8' }}>
            {errors.branch_office_id}
          </label>
        )}
      </Col>
      <Col xs={12} sm={7}>
        <label>
          Título <span className="text-danger">*</span>{' '}
          <small>
            (De una descripción para que se pueda encontrar facilmente)
          </small>
        </label>
        <Field name="title">
          {({ field }) => (
            <input
              type="text"
              {...field}
              className="form-control"
              maxLength="150"
            />
          )}
        </Field>{' '}
        {errors.title && touched.title && (
          <label style={{ color: '#da1717e8' }}>{errors.title}</label>
        )}
      </Col>
    </>
  );
};

ProjectData.propTypes = {
  realEstate: PropTypes.object,
  setValues: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  touched: PropTypes.object,
  data: PropTypes.object
};
